export function getTelephoneRegex() {
    return /^[0-9-+\s]{6,14}$/;
}
